import isNull from "../../../utils/NullChecking";
const DropdownCodeHandler = (DropDown, Value) => {
    if (!isNull(Value) && DropDown.length > 0) {
        const selectedType = DropDown.find(type => type.code + "" === Value + "");
        if (selectedType) {
            return selectedType.display;
        }
    }
    return null; // Return a default value if no match is found
};

export default DropdownCodeHandler;